export const DEVICE_TYPE = {
  WEBSITE: 'WEBSITE',
  MOBILE: 'MOBILE',
}

export const ROUND_CLOSE_TYPE = {
  ROUND_CLOSE: 'round-close',
  TEMPORARY_ROUND_CLOSE: 'temporary-round-close',
  EMPTY_LOTTERY: 'empty-lottery',
}

export const IMAGE_NAME_TYPE = {
  'round-close': 'ROUND_CLOSE',
  'temporary-round-close': 'TEMPORARY_ROUND_CLOSE',
  'empty-lottery': 'EMPTY_LOTTERY',
}

export const OUR_USER = { 
  firstName: 'วิสุทธิ์',
  lastName: 'ชอบซื้อหวย',
  nickName: 'เศรษฐีกรุงเทพ',
  userId: 'P8447565',
  id: 'P8447565',
  province: 'กรุงเทพมหานคร',
  phone: '0821587804',
}
